import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Novurem Patisserie - Feinste Confiserie in Ettlingen</title>
        <meta name="description" content="Novurem Patisserie - Boutique Konditorei mit feinsten Pralinen, Macarons, Torten und Pralinen in Ettlingen. Handwerkskunst mit Kirschrot, Vanillecreme und Pistazie." />
      </Helmet>

      <div className="privacy-policy">
      <h1>Datenschutzerklärung</h1>
      <p><strong>Stand: Februar 2024</strong></p>

      <section className="privacy-section">
        <h2>1. Verantwortlicher für die Datenverarbeitung</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        </p>
        <address>
          Novurem Patisserie<br />
          [Straße und Hausnummer]<br />
          76275 Ettlingen<br />
          Deutschland<br />
          E-Mail: info@novurem.com<br />
          Telefon: [Telefonnummer]
        </address>
      </section>

      <section className="privacy-section">
        <h2>2. Allgemeine Hinweise</h2>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>
        <p>
          Diese Datenschutzerklärung informiert Sie darüber, wie wir personenbezogene Daten im Rahmen unseres Online-Shops verarbeiten. Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z.B. Name, Adresse, E-Mail-Adresse, Zahlungsdaten.
        </p>
      </section>

      <section className="privacy-section">
        <h2>3. Hosting</h2>
        <p>
          Diese Website wird bei einem externen Dienstleister gehostet (Hostinger). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich insbesondere um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten handeln.
        </p>
        <p>
          Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </section>

      <section className="privacy-section">
        <h2>4. Datenerfassung auf dieser Website</h2>
        
        <h3>4.1 Cookies</h3>
        <p>
          Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
        </p>
        <p>
          Wir verwenden Cookies, um unser Angebot nutzerfreundlicher, effektiver und sicherer zu gestalten. Die meisten der von uns verwendeten Cookies sind so genannte "Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
        </p>
        <p>
          Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von technisch notwendigen Cookies ist Art. 6 Abs. 1 lit. f DSGVO. Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies zu Analysezwecken ist bei Vorliegen einer diesbezüglichen Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
        </p>

        <h3>4.2 Kontaktformular und Kontaktaufnahme</h3>
        <p>
          Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </section>

      <section className="privacy-section">
        <h2>5. Bestellabwicklung im Online-Shop</h2>
        
        <h3>5.1 Erhebung und Verarbeitung von Bestelldaten</h3>
        <p>
          Wenn Sie in unserem Online-Shop eine Bestellung aufgeben, erheben wir folgende Daten:
        </p>
        <ul>
          <li>Name, Vorname</li>
          <li>Lieferadresse</li>
          <li>Rechnungsadresse</li>
          <li>E-Mail-Adresse</li>
          <li>Telefonnummer (optional)</li>
          <li>Zahlungsinformationen</li>
        </ul>
        <p>
          Die Verarbeitung dieser Daten erfolgt zur Vertragsabwicklung gemäß Art. 6 Abs. 1 lit. b DSGVO. Die Angabe der Daten ist zur Vertragserfüllung erforderlich.
        </p>

        <h3>5.2 Zahlungsabwicklung</h3>
        <p>
          Für die Zahlungsabwicklung in unserem Online-Shop nutzen wir folgende Zahlungsdienstleister:
        </p>
        <ul>
          <li>PayPal</li>
          <li>Stripe</li>
          <li>Kreditkarte (Visa, Mastercard, American Express)</li>
          <li>SEPA-Lastschrift</li>
          <li>Apple Pay / Google Pay</li>
        </ul>
        <p>
          Die Übermittlung Ihrer Zahlungsdaten an den jeweiligen Zahlungsdienstleister erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren und effizienten Zahlungsabwicklung).
        </p>
        <p>
          Für die jeweiligen Datenschutzerklärungen der Zahlungsdienstleister verweisen wir auf deren Websites.
        </p>
      </section>

      <section className="privacy-section">
        <h2>6. Versanddienstleister</h2>
        <p>
          Zur Lieferung Ihrer Bestellung geben wir Ihre Daten an das mit der Lieferung beauftragte Versandunternehmen weiter (z.B. DHL, Hermes, DPD). Die Weitergabe erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Vertragserfüllung.
        </p>
      </section>

      <section className="privacy-section">
        <h2>7. Ihre Rechte als betroffene Person</h2>
        <p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit folgende Rechte:</p>
        <ul>
          <li><strong>Recht auf Auskunft</strong> (Art. 15 DSGVO): Sie haben das Recht, Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu verlangen.</li>
          <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO): Sie haben das Recht, unrichtige Daten berichtigen zu lassen.</li>
          <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO): Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
          <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO): Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen.</li>
          <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO): Sie haben das Recht, Ihre Daten in einem maschinenlesbaren Format zu erhalten.</li>
          <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO): Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten Widerspruch einzulegen.</li>
          <li><strong>Recht auf Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO): Sie haben das Recht, eine erteilte Einwilligung jederzeit zu widerrufen.</li>
          <li><strong>Recht auf Beschwerde bei einer Aufsichtsbehörde</strong> (Art. 77 DSGVO): Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>8. Speicherdauer</h2>
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke erforderlich ist oder wie es die gesetzlichen Aufbewahrungsfristen vorsehen (z.B. handels- und steuerrechtliche Aufbewahrungsfristen nach HGB und AO, in der Regel 6-10 Jahre).
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. SSL- bzw. TLS-Verschlüsselung</h2>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
        </p>
      </section>

      <section className="privacy-section">
        <h2>10. Google Analytics</h2>
        <p>
          Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
        </p>
        <p>
          Google Analytics verwendet Cookies, die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
        </p>
        <p>
          Die Verwendung von Google Analytics erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Sie können Ihre Einwilligung jederzeit widerrufen.
        </p>
        <p>
          Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können.
        </p>
      </section>

      <section className="privacy-section">
        <h2>11. Social Media</h2>
        <p>
          Wir sind auf verschiedenen Social-Media-Plattformen präsent (z.B. Instagram, Facebook, TikTok). Wenn Sie uns auf diesen Plattformen besuchen, gelten die Datenschutzerklärungen der jeweiligen Plattformbetreiber.
        </p>
        <p>
          Unsere Social-Media-Kanäle sind als Fanpage bzw. Unternehmensseite eingebunden. Die Verarbeitung Ihrer Daten auf diesen Seiten erfolgt auf Grundlage unserer berechtigten Interessen (Art. 6 Abs. 1 lit. f DSGVO) an einer effektiven Informations- und Kommunikationsmöglichkeit mit unseren Kunden und Interessenten.
        </p>
      </section>

      <section className="privacy-section">
        <h2>12. Map-Dienste (Google Maps)</h2>
        <p>
          Wir nutzen auf unserer Website den Kartendienst Google Maps zur Darstellung unseres Standorts. Anbieter ist die Google Ireland Limited. Bei der Nutzung von Google Maps werden Daten über die Nutzung der Kartenfunktionen durch Besucher erhoben, verarbeitet und genutzt.
        </p>
      </section>

      <section className="privacy-section">
        <h2>13. Änderungen dieser Datenschutzerklärung</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
        </p>
      </section>
    </div>
  
    </>);
};

export default PrivacyPolicy;